declare global {
  interface Document {
      documentMode?: any;
  }
}

import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { UserService } from '../common/services/user.service';
import { LoginService } from '../common/components/login/login.service';
import { environment } from '../environments/environment';
import { Subscription } from 'rxjs';
import { HttpWrapperService } from '../common/services/http-wrapper.service';
import { HeaderService } from '../common/components/header/header.service';
import { TagsService } from '../common/services/tags.service';
import { routes } from './routes.constant';
import { Title } from "@angular/platform-browser";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  //title = 'dvps';
  userLoggedIn: String;
  fullNodeName: any;
  nodeName: any;
  showLoader: Boolean = false;
  loaserSubscription: Subscription;
  activeRoute: String;
  successfullLogin: Boolean = false;
  isIE: any;
  lastRoute = '';
  routes = routes;
  
  constructor(private userService: UserService, private router: Router, private loginService: LoginService, 
    private httpWrapperService: HttpWrapperService, private headerService: HeaderService, private tagsService: TagsService, 
    private title: Title) {

    userService.apiHost = environment.useCurrentHost ? window.location.origin+'/' : environment.host;
    if(this.userService.getCookie('hsbcneturl')) {
      localStorage.setItem('hsbcneturl', this.userService.getCookie('hsbcneturl'));
    }
    userService.hsbcNetUrl = localStorage.getItem('hsbcneturl') ? localStorage.getItem('hsbcneturl') : environment.hsbcNetUrl;
    
    this.isIE = /*@cc_on!@*/false || !!document.documentMode;
    //console.log('isIE', this.isIE);
    
    this.userLoggedIn = loginService.loggedIn;
	
	  router.events.forEach((event) => {
        if(event instanceof NavigationStart) {
          //console.log(loginService.loggedIn, event.url);
          this.activeRoute = event.url;
          this.userLoggedIn = loginService.loggedIn;
          /* if(event.url !== '/login' && !that.nodeName && this.userLoggedIn) {
            //that.getUserData();
          } */

          if(this.activeRoute == routes.DIGITAL_HUB) {
            this.title.setTitle('Security Services Applications');
          } else {
            this.title.setTitle('Digital Vault');
          }
          
        }
        if(event instanceof NavigationEnd) {
          if(this.lastRoute == event.url) {
            this.headerService.refresh(event.url);
          }
          this.lastRoute = event.url;
        }
        // NavigationEnd
    	  // NavigationCancel
    	  // NavigationError
       // RoutesRecognized
    });
    
    this.loaserSubscription = this.httpWrapperService.loaderFlag.subscribe(
      (val) => {
        this.showLoader = (val === 'Y') ? true : false;
      }
    );

    this.tagsService.setConfig();
  }

  ngOnInit() {
    //this.getUserData();
  }
  
  /* getUserData(): void {
    //let that = this;
    this.userService.getUserData()
      .subscribe( res => {
          //that.fullNodeName = res.me;
          //that.nodeName = res.me.split(",")[2].split("=")[1];
          //console.log('getUserData', res);
		    },
        error => {
          //console.log(error);
        });
  } */

}
